import { useHistory } from 'react-router-dom';
import _ from 'lodash';

import { apiList, getCancelData } from '../api/callAPI';

import useGlobalStatus from './useGlobalStatus';
import useApiError from './useApiError';
import useCancel from '../hook/useCancel';
import useReportStatus from './useReportStatus';

import { MODAL_CREATE_REPORT } from '../components/modal/constants';

import { MEDIA_DATA } from '../constants/mediaData';
import * as alertConstants from '../constants/alertMsg';

import { scrollToAnchor } from '../utils/commonUtils';

// Create or update a report.

const useModifyReport = (media) => {
  const history = useHistory();
  const { currentActiveData, setCurrentActiveData, entryPath, setModalName, setModalContent, setIsModalOpen, setModalData } = useGlobalStatus();
  const { handleApiErrorStatus } = useApiError();
  const { cancelData, setCancelData } = useCancel();
  const { setIsLoading, setIsProcessing } = useReportStatus();

  const getSendList = (reportName) => {
    let call;
    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }
    call = getCancelData();
    setCancelData(call);

    fetchReportList(call.token, reportName);
  }

  const fetchReportList = (cancelToken, reportName) => {
    let result;
    result = apiList[MEDIA_DATA[media].api.reportList]({
      page: 0,
      size: 10,
      sort: null,
      order: null
    }, cancelToken)

    result.then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

      if (res.status === 200) {
        confirmReport(res.data.result.content, reportName);
      } else {
        handleApiErrorStatus(res);
        if (res.status !== 401) {
          history.push(MEDIA_DATA[media].sendListUrl);
        }
      }
    })
  }

  //確認匯出報表
  const confirmReport = (sendList, reportName) => {
    setIsProcessing('downloadReport');

    if (entryPath.includes("create")) {
      setCurrentActiveData(sendList[0]);
    }
    setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
    setModalData({ reportName });
    setIsModalOpen(true);
    setIsProcessing(false);
    setIsLoading(false);
  }

  const handleCreateReport = (downloadOrSend, reportName) => {
    if (downloadOrSend === 'downloadData') {
      getSendList(reportName);
    } else if (downloadOrSend === 'sendData') {
      setIsLoading(false);
      setModalName('alert');
      setTimeout(() => {
        setModalName('');
        history.push(MEDIA_DATA[media].sendListUrl);
      }, 2000)
    }
  }

  const handleEditReport = (downloadOrSend, reportName) => {
    setIsLoading(false);
    if (downloadOrSend === 'downloadData') {
      setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
      setModalData({ reportName });
      setIsModalOpen(true);

    } else if (downloadOrSend === 'sendData') {
      setModalName('alert');
      setTimeout(() => {
        setModalName('');
        history.push(MEDIA_DATA[media].sendListUrl);
      }, 2000)
    }
  }

  const fetchModifyReport = (apiFn, query, onSuccess) => {
    setModalName('');
    setIsLoading(true);
    apiFn(query)
      .then(res => {
        if (res.status === 200) {
          onSuccess();
        } else {
          scrollToAnchor('scrollTop');
          handleApiErrorStatus(res);
          setIsLoading(false);
        }
      })
  }

  const handleModifyReportApi = (type, storeReportData, downloadOrSend, reportName) => {
    let apiFn;
    let query;

    if (type === 'create') {
      apiFn = apiList[MEDIA_DATA[media].api.createReport];
      query = storeReportData;
      fetchModifyReport(apiFn, query, () => {
        handleCreateReport(downloadOrSend, reportName)
      })

    } else {
      apiFn = apiList[MEDIA_DATA[media].api.updateReport];
      query = { data: storeReportData, config: { weeklyReportId: currentActiveData.weeklyReportId } };
      fetchModifyReport(apiFn, query, () => {
        handleEditReport(downloadOrSend, reportName)
      })
    }
  }

  return {
    handleModifyReportApi
  }
}

export default useModifyReport;